<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="GongYingShangList" data-title="供应商管理">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="编码" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :key="row.name" :value1="row.name" :value2="row.number">
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                  @click="
                    $openMenu({
                      path: 'GongYingShangDetail',
                      title: '供应商详情-' + row.name,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                >
                  <strong>{{ row.name }}</strong>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="联系人" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.address" :key="row.address">
              <template #top>
                <div class="flex items-center gap-x-3">
                  <text>{{ row.contact_name }}</text>
                  <c_sex :value="row.contact_title == '先生' ? '男' : '女'" />
                  <text>{{ $phoneFormat(row.contact_phone) }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="协议期">
          <template #default="{ row }">
            <text v-if="row.contract_time">
              {{ row.contract_time + " ~ " + row.contract_time_end }}
            </text>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          label="账户余额"
          align="center"
          prop="amount"
          :formatter="$tab_MoneyFormat"
        >
        </el-table-column>
        <!-- <el-table-column
          label="支付中"
          align="center"
          prop="supplierPurchaseAmount.paying_amount"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="已支付"
          align="center"
          prop="supplierPurchaseAmount.paid_amount"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="未冲销"
          align="center"
          prop="supplierPurchaseAmount"
          :formatter="$tab_PriceFormat"
        /> -->
        <el-table-column label="负责人" :width="140">
          <template #default="{ row }">
            <text>{{ row.belonger_name }}</text>
            <text class="text-gray-400 text-xs ml-1">
              {{ row.belonger_department_name }}
            </text>
          </template>
        </el-table-column>
        <el-table-column label="状态" :width="70" align="center" fixed="right">
          <template #default="{ row }">
            <text v-if="row.status == 1" class="text-blue-500">启用</text>
            <text v-else class="text-red-500">停用</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="320">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="success"
              :icon="Connection"
              link
              @click="
                $openMenu({
                  path: 'GongYingShangDetail',
                  title: '供应商详情-' + row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              管理
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>

    <el-dialog
      v-model="state.showInfo"
      :title="`${state.selectId ? '编辑' : '新建'}供应商`"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showInfo = false;
        }
      "
      :lock-scroll="false"
    >
      <c_info
        :id="state.selectId"
        @close="
          state.showInfo = false;
          onLoad();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { supplier_page, supplier_delete } from "@/http/supplier";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      supplier_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(supplier_delete, row.id, onLoad, {
        filed: "供应商",
        name: row.name,
      });
    };

    return { state, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
